export const DOWNLOAD_RESOURCE_PANEL_ID = "download-product-resources";

/** 立即将下载页面定位到整个文档顶部。 */
export function scrollDownloadPageToTop() {
  window.scrollTo({ behavior: "instant", left: 0, top: 0 });
}

/** 立即将下载资源面板定位到顶部，并保留页面定义的 Header 间距。 */
export function scrollDownloadResourcePanelToTop() {
  document.getElementById(DOWNLOAD_RESOURCE_PANEL_ID)?.scrollIntoView({
    behavior: "instant",
    block: "start",
  });
}
